var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lifeBar"},_vm._l((Math.max(0, _vm.lives)),function(i){return _c('heart',{key:i,staticClass:"lifeBar__heart",attrs:{"delay":i * 0.08}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }